import { Switch, useLocation } from "react-router";
import { AnimatePresence } from "framer-motion";

export default function AnimatedSwitch({ children }: any) {
	const location = useLocation();
	return (
		<AnimatePresence mode="sync" initial={false}>
			<Switch location={location} key={location.key}>
				{children}
			</Switch>
		</AnimatePresence>
	);
}
